import { UnionKeyToValue } from "./base-types";

// List of cultures was generated on Windows 10 Pro using the following command:
// [CultureInfo]::GetCultures([System.Globalization.CultureTypes]::SpecificCultures) | Select -ExpandProperty Name | ConvertTo-Json -Compress

type CultureInvariant = "Invariant";

const CONSTANTS: UnionKeyToValue<CultureInvariant> = {
    Invariant: "Invariant",
};

export type NoneInvariantCultureInfo =
    | "aa-DJ"
    | "aa-ER"
    | "aa-ET"
    | "af-NA"
    | "af-ZA"
    | "agq-CM"
    | "ak-GH"
    | "am-ET"
    | "ar-001"
    | "ar-AE"
    | "ar-BH"
    | "ar-DJ"
    | "ar-DZ"
    | "ar-EG"
    | "ar-ER"
    | "ar-IL"
    | "ar-IQ"
    | "ar-JO"
    | "ar-KM"
    | "ar-KW"
    | "ar-LB"
    | "ar-LY"
    | "ar-MA"
    | "ar-MR"
    | "ar-OM"
    | "ar-PS"
    | "ar-QA"
    | "ar-SA"
    | "ar-SD"
    | "ar-SO"
    | "ar-SS"
    | "ar-SY"
    | "ar-TD"
    | "ar-TN"
    | "ar-YE"
    | "arn-CL"
    | "as-IN"
    | "asa-TZ"
    | "ast-ES"
    | "az-Cyrl-AZ"
    | "az-Latn-AZ"
    | "ba-RU"
    | "bas-CM"
    | "be-BY"
    | "bem-ZM"
    | "bez-TZ"
    | "bg-BG"
    | "bin-NG"
    | "bm-Latn-ML"
    | "bn-BD"
    | "bn-IN"
    | "bo-CN"
    | "bo-IN"
    | "br-FR"
    | "brx-IN"
    | "bs-Cyrl-BA"
    | "bs-Latn-BA"
    | "byn-ER"
    | "ca-AD"
    | "ca-ES"
    | "ca-ES-valencia"
    | "ca-FR"
    | "ca-IT"
    | "ce-RU"
    | "cgg-UG"
    | "chr-Cher-US"
    | "co-FR"
    | "cs-CZ"
    | "cu-RU"
    | "cy-GB"
    | "da-DK"
    | "da-GL"
    | "dav-KE"
    | "de-AT"
    | "de-BE"
    | "de-CH"
    | "de-DE"
    | "de-IT"
    | "de-LI"
    | "de-LU"
    | "dje-NE"
    | "dsb-DE"
    | "dua-CM"
    | "dv-MV"
    | "dyo-SN"
    | "dz-BT"
    | "ebu-KE"
    | "ee-GH"
    | "ee-TG"
    | "el-CY"
    | "el-GR"
    | "en-001"
    | "en-029"
    | "en-150"
    | "en-AG"
    | "en-AI"
    | "en-AS"
    | "en-AT"
    | "en-AU"
    | "en-BB"
    | "en-BE"
    | "en-BI"
    | "en-BM"
    | "en-BS"
    | "en-BW"
    | "en-BZ"
    | "en-CA"
    | "en-CC"
    | "en-CH"
    | "en-CK"
    | "en-CM"
    | "en-CX"
    | "en-CY"
    | "en-DE"
    | "en-DK"
    | "en-DM"
    | "en-ER"
    | "en-FI"
    | "en-FJ"
    | "en-FK"
    | "en-FM"
    | "en-GB"
    | "en-GD"
    | "en-GG"
    | "en-GH"
    | "en-GI"
    | "en-GM"
    | "en-GU"
    | "en-GY"
    | "en-HK"
    | "en-ID"
    | "en-IE"
    | "en-IL"
    | "en-IM"
    | "en-IN"
    | "en-IO"
    | "en-JE"
    | "en-JM"
    | "en-KE"
    | "en-KI"
    | "en-KN"
    | "en-KY"
    | "en-LC"
    | "en-LR"
    | "en-LS"
    | "en-MG"
    | "en-MH"
    | "en-MO"
    | "en-MP"
    | "en-MS"
    | "en-MT"
    | "en-MU"
    | "en-MW"
    | "en-MY"
    | "en-NA"
    | "en-NF"
    | "en-NG"
    | "en-NL"
    | "en-NR"
    | "en-NU"
    | "en-NZ"
    | "en-PG"
    | "en-PH"
    | "en-PK"
    | "en-PN"
    | "en-PR"
    | "en-PW"
    | "en-RW"
    | "en-SB"
    | "en-SC"
    | "en-SD"
    | "en-SE"
    | "en-SG"
    | "en-SH"
    | "en-SI"
    | "en-SL"
    | "en-SS"
    | "en-SX"
    | "en-SZ"
    | "en-TC"
    | "en-TK"
    | "en-TO"
    | "en-TT"
    | "en-TV"
    | "en-TZ"
    | "en-UG"
    | "en-UM"
    | "en-US"
    | "en-VC"
    | "en-VG"
    | "en-VI"
    | "en-VU"
    | "en-WS"
    | "en-ZA"
    | "en-ZM"
    | "en-ZW"
    | "eo-001"
    | "es-419"
    | "es-AR"
    | "es-BO"
    | "es-BR"
    | "es-BZ"
    | "es-CL"
    | "es-CO"
    | "es-CR"
    | "es-CU"
    | "es-DO"
    | "es-EC"
    | "es-ES"
    | "es-GQ"
    | "es-GT"
    | "es-HN"
    | "es-MX"
    | "es-NI"
    | "es-PA"
    | "es-PE"
    | "es-PH"
    | "es-PR"
    | "es-PY"
    | "es-SV"
    | "es-US"
    | "es-UY"
    | "es-VE"
    | "et-EE"
    | "eu-ES"
    | "ewo-CM"
    | "fa-IR"
    | "ff-CM"
    | "ff-GN"
    | "ff-Latn-SN"
    | "ff-MR"
    | "ff-NG"
    | "fi-FI"
    | "fil-PH"
    | "fo-DK"
    | "fo-FO"
    | "fr-029"
    | "fr-BE"
    | "fr-BF"
    | "fr-BI"
    | "fr-BJ"
    | "fr-BL"
    | "fr-CA"
    | "fr-CD"
    | "fr-CF"
    | "fr-CG"
    | "fr-CH"
    | "fr-CI"
    | "fr-CM"
    | "fr-DJ"
    | "fr-DZ"
    | "fr-FR"
    | "fr-GA"
    | "fr-GF"
    | "fr-GN"
    | "fr-GP"
    | "fr-GQ"
    | "fr-HT"
    | "fr-KM"
    | "fr-LU"
    | "fr-MA"
    | "fr-MC"
    | "fr-MF"
    | "fr-MG"
    | "fr-ML"
    | "fr-MQ"
    | "fr-MR"
    | "fr-MU"
    | "fr-NC"
    | "fr-NE"
    | "fr-PF"
    | "fr-PM"
    | "fr-RE"
    | "fr-RW"
    | "fr-SC"
    | "fr-SN"
    | "fr-SY"
    | "fr-TD"
    | "fr-TG"
    | "fr-TN"
    | "fr-VU"
    | "fr-WF"
    | "fr-YT"
    | "fur-IT"
    | "fy-NL"
    | "ga-IE"
    | "gd-GB"
    | "gl-ES"
    | "gn-PY"
    | "gsw-CH"
    | "gsw-FR"
    | "gsw-LI"
    | "gu-IN"
    | "guz-KE"
    | "gv-IM"
    | "ha-Latn-GH"
    | "ha-Latn-NE"
    | "ha-Latn-NG"
    | "haw-US"
    | "he-IL"
    | "hi-IN"
    | "hr-BA"
    | "hr-HR"
    | "hsb-DE"
    | "hu-HU"
    | "hy-AM"
    | "ia-001"
    | "ia-FR"
    | "ibb-NG"
    | "id-ID"
    | "ig-NG"
    | "ii-CN"
    | "is-IS"
    | "it-CH"
    | "it-IT"
    | "it-SM"
    | "it-VA"
    | "iu-Cans-CA"
    | "iu-Latn-CA"
    | "ja-JP"
    | "jgo-CM"
    | "jmc-TZ"
    | "jv-Java-ID"
    | "jv-Latn-ID"
    | "ka-GE"
    | "kab-DZ"
    | "kam-KE"
    | "kde-TZ"
    | "kea-CV"
    | "khq-ML"
    | "ki-KE"
    | "kk-KZ"
    | "kkj-CM"
    | "kl-GL"
    | "kln-KE"
    | "km-KH"
    | "kn-IN"
    | "ko-KP"
    | "ko-KR"
    | "kok-IN"
    | "kr-NG"
    | "ks-Arab-IN"
    | "ks-Deva-IN"
    | "ksb-TZ"
    | "ksf-CM"
    | "ksh-DE"
    | "ku-Arab-IQ"
    | "ku-Arab-IR"
    | "kw-GB"
    | "ky-KG"
    | "la-001"
    | "lag-TZ"
    | "lb-LU"
    | "lg-UG"
    | "lkt-US"
    | "ln-AO"
    | "ln-CD"
    | "ln-CF"
    | "ln-CG"
    | "lo-LA"
    | "lrc-IQ"
    | "lrc-IR"
    | "lt-LT"
    | "lu-CD"
    | "luo-KE"
    | "luy-KE"
    | "lv-LV"
    | "mas-KE"
    | "mas-TZ"
    | "mer-KE"
    | "mfe-MU"
    | "mg-MG"
    | "mgh-MZ"
    | "mgo-CM"
    | "mi-NZ"
    | "mk-MK"
    | "ml-IN"
    | "mn-MN"
    | "mn-Mong-CN"
    | "mn-Mong-MN"
    | "mni-IN"
    | "moh-CA"
    | "mr-IN"
    | "ms-BN"
    | "ms-MY"
    | "ms-SG"
    | "mt-MT"
    | "mua-CM"
    | "my-MM"
    | "mzn-IR"
    | "naq-NA"
    | "nb-NO"
    | "nb-SJ"
    | "nd-ZW"
    | "nds-DE"
    | "nds-NL"
    | "ne-IN"
    | "ne-NP"
    | "nl-AW"
    | "nl-BE"
    | "nl-BQ"
    | "nl-CW"
    | "nl-NL"
    | "nl-SR"
    | "nl-SX"
    | "nmg-CM"
    | "nn-NO"
    | "nnh-CM"
    | "nqo-GN"
    | "nr-ZA"
    | "nso-ZA"
    | "nus-SS"
    | "nyn-UG"
    | "oc-FR"
    | "om-ET"
    | "om-KE"
    | "or-IN"
    | "os-GE"
    | "os-RU"
    | "pa-Arab-PK"
    | "pa-IN"
    | "pap-029"
    | "pl-PL"
    | "prg-001"
    | "prs-AF"
    | "ps-AF"
    | "pt-AO"
    | "pt-BR"
    | "pt-CH"
    | "pt-CV"
    | "pt-GQ"
    | "pt-GW"
    | "pt-LU"
    | "pt-MO"
    | "pt-MZ"
    | "pt-PT"
    | "pt-ST"
    | "pt-TL"
    | "quc-Latn-GT"
    | "quz-BO"
    | "quz-EC"
    | "quz-PE"
    | "rm-CH"
    | "rn-BI"
    | "ro-MD"
    | "ro-RO"
    | "rof-TZ"
    | "ru-BY"
    | "ru-KG"
    | "ru-KZ"
    | "ru-MD"
    | "ru-RU"
    | "ru-UA"
    | "rw-RW"
    | "rwk-TZ"
    | "sa-IN"
    | "sah-RU"
    | "saq-KE"
    | "sbp-TZ"
    | "sd-Arab-PK"
    | "sd-Deva-IN"
    | "se-FI"
    | "se-NO"
    | "se-SE"
    | "seh-MZ"
    | "ses-ML"
    | "sg-CF"
    | "shi-Latn-MA"
    | "shi-Tfng-MA"
    | "si-LK"
    | "sk-SK"
    | "sl-SI"
    | "sma-NO"
    | "sma-SE"
    | "smj-NO"
    | "smj-SE"
    | "smn-FI"
    | "sms-FI"
    | "sn-Latn-ZW"
    | "so-DJ"
    | "so-ET"
    | "so-KE"
    | "so-SO"
    | "sq-AL"
    | "sq-MK"
    | "sq-XK"
    | "sr-Cyrl-BA"
    | "sr-Cyrl-ME"
    | "sr-Cyrl-RS"
    | "sr-Cyrl-XK"
    | "sr-Latn-BA"
    | "sr-Latn-ME"
    | "sr-Latn-RS"
    | "sr-Latn-XK"
    | "ss-SZ"
    | "ss-ZA"
    | "ssy-ER"
    | "st-LS"
    | "st-ZA"
    | "sv-AX"
    | "sv-FI"
    | "sv-SE"
    | "sw-CD"
    | "sw-KE"
    | "sw-TZ"
    | "sw-UG"
    | "syr-SY"
    | "ta-IN"
    | "ta-LK"
    | "ta-MY"
    | "ta-SG"
    | "te-IN"
    | "teo-KE"
    | "teo-UG"
    | "tg-Cyrl-TJ"
    | "th-TH"
    | "ti-ER"
    | "ti-ET"
    | "tig-ER"
    | "tk-TM"
    | "tn-BW"
    | "tn-ZA"
    | "to-TO"
    | "tr-CY"
    | "tr-TR"
    | "ts-ZA"
    | "tt-RU"
    | "twq-NE"
    | "tzm-Arab-MA"
    | "tzm-Latn-DZ"
    | "tzm-Latn-MA"
    | "tzm-Tfng-MA"
    | "ug-CN"
    | "uk-UA"
    | "ur-IN"
    | "ur-PK"
    | "uz-Arab-AF"
    | "uz-Cyrl-UZ"
    | "uz-Latn-UZ"
    | "vai-Latn-LR"
    | "vai-Vaii-LR"
    | "ve-ZA"
    | "vi-VN"
    | "vo-001"
    | "vun-TZ"
    | "wae-CH"
    | "wal-ET"
    | "wo-SN"
    | "xh-ZA"
    | "xog-UG"
    | "yav-CM"
    | "yi-001"
    | "yo-BJ"
    | "yo-NG"
    | "zgh-Tfng-MA"
    | "zh-CN"
    | "zh-Hans-HK"
    | "zh-Hans-MO"
    | "zh-HK"
    | "zh-MO"
    | "zh-SG"
    | "zh-TW"
    | "zu-ZA";

export type CultureInfo = NoneInvariantCultureInfo | CultureInvariant;

export default CultureInfo;
export const InvariantCulture = CONSTANTS.Invariant;
